import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'
import { TokenVestingHistoryFragment } from '@src/graphql/fragment/reward'

export default gql`
  query GetVestingHistories($input: TokenVestingHistoriesInput!) {
    getMyTokenVestingHistories(input: $input) {
      edges {
        node {
          ...TokenVestingHistory
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${TokenVestingHistoryFragment}
  ${PageInfoFragment}
`
